<app-larged-tuile
  icon="fa-kit fa-picto-electrolyseur"
  [title]="'P0003607.dashboard.electrolyseur' | translate"
  [buttons]="buttonMode"
  [status]="
    buttons[this.actionStack!.getValue('esSEtatSortieElectrolyseur')].title!
      | translate
  "
  [statusMode]="
    this.actionStack!.getValue('esSAlarme') === 1
      ? 'alarm'
      : buttons[this.actionStack!.getValue('esSEtatSortieElectrolyseur')]
          .status!
  "
  [selectItem]="this.actionStack!.getValue('esCModeFonctionnement')"
  (onPressSetting)="this.openProductModal()"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.ElectrolyseurStandard_Controle,
      'esCModeFonctionnement',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-larged-tuile>
